import { CoreDropdownOption } from '../dropdown/dropdown.type';
import { MessageComposerToolbarOption } from './message-composer-editor.types';

export const MESSAGE_COMPOSER_BLOCK_OPTIONS: readonly CoreDropdownOption[] = [
  { value: 'p', label: 'Texto' },
  { value: 'h3', label: 'Título' },
];

export const MESSAGE_COMPOSER_TOOLBAR_OPTIONS: readonly MessageComposerToolbarOption[] = [
  {
    type: 'command',
    value: 'bold',
    label: 'Negrita',
    content: 'B',
    style: 'strong',
  },
  {
    type: 'command',
    value: 'italic',
    label: 'Cursiva',
    content: 'I',
    style: 'italic',
  },
  {
    type: 'command',
    value: 'underline',
    label: 'Subrayado',
    content: 'U',
    style: 'underline',
  },
  {
    type: 'command',
    value: 'insertUnorderedList',
    label: 'Lista con viñetas',
    content: '\u2022',
    dividerBefore: true,
  },
  {
    type: 'command',
    value: 'insertOrderedList',
    label: 'Lista numerada',
    content: '1.',
    style: 'ordered',
  },
  {
    type: 'block',
    value: 'blockquote',
    label: 'Cita',
    content: '\u201d',
    style: 'quote',
  },
  {
    type: 'block',
    value: 'pre',
    label: 'Código',
    content: '</>',
    style: 'code',
  },
];
